export const clog = () => {
  console.log = function() {}
}
